import React, {useContext, useEffect, useState} from "react";
import { Slider, Rail, Handles, Tracks } from 'react-compound-slider'
import isEqual from 'lodash/isEqual';

const domain = [0, 100000];

const container = {
    position: 'absolute',
    top: 50,
    width: 415,//'80%',
    height: 102,
    touchAction: 'none',
    backgroundColor: '#2c3c4e',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 5,
    display: 'flex',
    flexDirection: 'column',
}

const row = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    flex: 1,
}

const sliderStyle = {
    position: 'relative',
    width: '100%',
    touchAction: 'none',
    backgroundColor: '#2c3c4e',
    justifyContent: 'center',
    alignItems: 'center',
    // display: 'flex',
    // zIndex: 1,
}

const textStyle = {
    flex: 1,
    // fontFamily: 'SFProDisplay',
    fontSize: 12,
    letterSpacing: 0.13,
    color: '#FFFFFF',
    paddingLeft: 26,
    paddingRight: 26,
}

const selectPriceStyle = {
    // fontFamily: 'SFProDisplay',
    fontSize: 16,
    fontHeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 0.18,
    textAlign: 'center',
    color: '#ffffff',
    paddingBottom: 17,
}

const SliderRail = ({ getRailProps }) => (
    <> 
        <div style={{
            position: 'absolute',
            width: '100%',
            height: 1.5,
            transform: 'translate(0%, -50%)',
            borderRadius: 7,
            cursor: 'pointer',
        }} {...getRailProps()} />
        <div style={{
            position: 'absolute',
            width: '100%',
            height: 1.5,
            transform: 'translate(0%, -50%)',
            borderRadius: 7,
            pointerEvents: 'none',
            backgroundColor: 'rgb(155,155,155)',
        }} />
    </>
);

const Handle = ({
    domain: [min, max],
    handle: { id, value, percent },
    disabled,
    getHandleProps,
}) => {
    return (
      <>
        <div
          style={{
            left: `${percent}%`,
            position: 'absolute',
            transform: 'translate(-50%, -50%)',
            WebkitTapHighlightColor: 'rgba(0,0,0,0)',
            zIndex: 5,
            width: 28,
            height: 42,
            cursor: 'pointer',
            // border: '1px solid white',
            backgroundColor: 'none',
          }}
          {...getHandleProps(id)}
        />
        <div
          role="slider"
          aria-valuemin={min}
          aria-valuemax={max}
          aria-valuenow={value}
          style={{
            left: `${percent}%`,
            position: 'absolute',
            transform: 'translate(-50%, -50%)',
            zIndex: 2,
            width: 19,
            height: 19,
            borderRadius: '50%',
            boxShadow: '1px 1px 1px 1px rgba(0, 0, 0, 0.3)',
            backgroundColor: disabled ? '#666' : '#ffffff',
          }}
        />
      </>
    )
  }

const Track = ({ source, target, getTrackProps, disabled }) => {
    return (
      <div
        style={{
          position: 'absolute',
          transform: 'translate(0%, -50%)',
          height: 1,
          zIndex: 1,
          backgroundColor: disabled ? '#999' : '#ffffff',
          borderRadius: 7,
          cursor: 'pointer',
          left: `${source.percent}%`,
          width: `${target.percent - source.percent}%`,
        }}
        {...getTrackProps()}
      />
    )
  }
  

const PriceSlider = ({
    isVisible = false,
    onUpdate = (value) => {},
    onChange = (value) => {},
    defaultValues = [0, 50000],
    currentValues = [0, 50000],
}) => {
    const [priceMin, setPriceMin] = useState(defaultValues[0]);
    const [priceMax, setPriceMax] = useState(defaultValues[1]);
    const changeCallback = (callback) => (value) => {
        const roundedMin = Math.ceil(value[0] /100) * 100;
        const roundedMax = Math.ceil(value[1] /100) * 100;
        setPriceMin(roundedMin);
        setPriceMax(roundedMax);
        callback(value);
    };
    useEffect(() => {
        if(!isEqual(currentValues, [priceMin, priceMax])) {
            setPriceMin(currentValues[0]);
            setPriceMax(currentValues[1]);
        }
    }, [currentValues]);
    return isVisible ?
    <div style={container}>
        <div style={row}>
            <div style={textStyle}>${domain[0].toLocaleString()}</div>
            <Slider
                step={200}
                onUpdate={changeCallback(onUpdate)}
                onChange={changeCallback(onChange)}
                rootStyle={sliderStyle}
                domain={domain}
                values={currentValues}
            >
                <Rail>
                    {({ getRailProps }) => {
                        // console.log('get', getRailProps())
                        return <SliderRail getRailProps={getRailProps} /> // render your clickable rail!
                    }}
                </Rail>
                <Handles>
                    {({ handles, getHandleProps }) => {
                        // render your handles!
                        // console.log('h', handles);
                        return <div>
                            {handles.map(handle => 
                                <Handle
                                    key={handle.id}
                                    handle={handle}
                                    domain={domain}
                                    getHandleProps={getHandleProps}
                                />
                            )}
                        </div>
                    }}
                </Handles>
                <Tracks right={false}>
                    {({ tracks, getTrackProps }) => (
                    <div className="slider-tracks">
                        {tracks.map(({ id, source, target }) => (
                        <Track
                            key={id}
                            source={source}
                            target={target}
                            getTrackProps={getTrackProps}
                        />
                        ))}
                    </div>
                    )}
                </Tracks>
            </Slider>
            <div style={textStyle}>${domain[1].toLocaleString()}</div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row'}}>
            <div style={selectPriceStyle}>${priceMin.toLocaleString()}</div>
            <div style={{...selectPriceStyle, paddingLeft: 8, paddingRight: 8}}>{`~`}</div>
            <div style={selectPriceStyle}>${priceMax.toLocaleString()}</div>
        </div>
    </div>
    
    : null;
};

export default PriceSlider;